export default __webpack_public_path__ + "static/media/contactWrite.bbca7814.svg";